import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { DBCheckBoxComment } from '_components'

class PatientCareCenterNoteObjectiveObsIADLImpairmentsPeds extends React.Component {
    render() {
    
            return (
                <PatientCareCenterNoteSection id='obj_obs_IADL' name='IADL Impairments' level={2} noChildPadding={true}>
                    
                    <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLCAREOTHERS'
                         className={styles.checkbox}
                         label='Care of others'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLCAREPETS'
                         className={styles.checkbox}
                         label='Care of pets'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>


                  <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLCOMM'
                         label='Communication management'
                         checkboxStyle={styles.checkbox_size}
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>


                  <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLMEAL'
                         checkboxStyle={styles.checkbox_size}
                         label='Meal preparation and cleanup'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>


                  <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLRELIGIOUS'
                         checkboxStyle={styles.checkbox_size}
                         label='Religious and spiritual activities and expression'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>


                  <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLSAFETY'
                         className={styles.checkbox}
                         checkboxStyle={styles.checkbox_size}
                         label='Safety and emergency maintenance'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLSHOP'
                         className={styles.checkbox}
                         label='Shopping'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLMAT'
                         className={styles.checkbox}
                         label='Materials management'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                     <div className={styles.gap}>
                      <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPIADLHOME'
                         className={styles.checkbox}
                         label='Home management'
                         textAreaStyle={styles.formTextArea}
                       />
                    </div>
                  </div>

                </PatientCareCenterNoteSection>
            );
    }

}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));
    return {
        noteId: noteId,
        opno: opno
    };
}

const connectedPatientCareCenterNoteObjectiveObsIADLImpairmentsPeds = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsIADLImpairmentsPeds);
export { connectedPatientCareCenterNoteObjectiveObsIADLImpairmentsPeds as PatientCareCenterNoteObjectiveObsIADLImpairmentsPeds };

